import Orchestrator from "./orchestrator";
import Header from "../Header";
import { IconPlus } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

export default  function Index(){

const navigate = useNavigate();

    return(
        <>
			<div className="container">
				<div className="flex w-full flex-row gap-6 items-center justify-between md:p-4">
                <h2 className="text-gray-900 text-4xl mt-4 font-bold mb-2">Orchestrator</h2>
					{/* <div className="flex flex-col">
						
						<button className="hover:bg-gray-200 text-gray-500 font-bold py-1 px-2 rounded-md inline-flex items-center border border-gray-200 bg-white focus:border-blue-500 focus:border-2 mb-2">
							
							<span>My Tools</span>
						</button>
						<button className="hover:bg-gray-200 text-gray-500 font-bold py-1 px-2 rounded-md inline-flex items-center border border-gray-200 bg-white focus:border-blue-500 focus:border-2 mb-2">
							
							<span>Market Place</span>
						</button>
					</div> */}
					<button className="hover:bg-gray-200 text-gray-500 font-bold py-1 px-2 rounded-md inline-flex items-center border border-gray-200 bg-white focus:border-blue-500 focus:border-2"
						onClick={
							() => navigate('/orchestrator/add')
					}>
						<IconPlus />
						<span>New</span>
					</button>
				</div>
			</div>
        </>
    )
}